var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"about-tabs__item"},[_c('router-link',{staticClass:"about-tabs__link",attrs:{"to":{ name: _vm.tab.link },"active-class":"active","exact":""}},[_vm._v(" "+_vm._s(_vm.$store.state.statics[_vm.tab.text])+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }